import { SET_DIRTY_STEP } from '../actions/constants';

const initialState = {
    dirtySteps: []
};

const reducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_DIRTY_STEP: {
            const isStepDirty = state.dirtySteps.indexOf(payload) !== -1;
            const dirtySteps = isStepDirty ? state.dirtySteps : [...state.dirtySteps, payload];

            return { dirtySteps };
        }

        default:
            return state;
    }
};

export default reducer;
